module.exports = __webpack_public_path__ + "static/media/ic_nav_01.9ba42aa4.svg";